import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconDirectionsBoat = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconDirectionsBoat",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M158-200 82-468q-3-12 3-28t23-22l52-18v-184q0-33 24-56t56-24h120v-80q0-17 12-28t28-12h160q17 0 29 12t11 28v80h120q33 0 57 24t23 56v184l52 18q21 8 25 24t1 26l-76 268q-40 0-74-15t-62-40q-11-11-26-11t-26 11q-28 24-62 40t-72 15l-19-1-18-3q-29-6-55-21t-48-35q-8-8-20-8t-21 8q-28 27-65 44t-76 16M480-40q-41 0-81-10t-79-30q-38 20-78 30t-82 10h-40q-17 0-28-11T80-80t12-28 28-12h40q36 0 72-10t67-29q10-6 21-6t21 6q22 14 51 23t54 12l17 2h17q36 0 72-9t67-28q10-6 21-6t21 6q31 20 67 30t72 9h40q17 0 29 12t11 28-11 29-29 11h-40q-42 0-82-10t-78-30q-38 20-78 30t-82 10M240-562l215-70q12-4 25-4t25 4l215 70v-158H240z"
  })
}));